import { makeStyles } from '@material-ui/core/styles';
import { colorConstant } from '../../style/Color.constant';

export default makeStyles(theme => ({
    floatingButton: {
        position: 'fixed',
        right: 20,
        bottom: 20,
        backgroundColor:'#014e8c'
    },
    active:{
        color:'#35ec35'
    },
    inactive:{
        color:'red'
    },
    buttonGroup:{
        textAlign:'right',
    },
    activeButton:{
        borderTopLeftRadius: '20px',
        borderBottomLeftRadius: '20px',
        background: '#fff',
        textTransform: "capitalize",
        border: '1px solid #eae2e2',
        "&:focus":{
            outline:'none',
            background: '#014e8c',
            color:'#fff'
        },
        "&:hover":{
            border: '1px solid #eae2e2',
        }
    },
    inActiveButton:{
        borderTopRightRadius: '20px',
        borderBottomRightRadius: '20px',
        background: '#fff',
        textTransform: "capitalize",
        border: '1px solid #eae2e2',
        "&:focus":{
            outline:'none',
            background: '#014e8c',
            color:'#fff'
        },
        "&:hover":{
            border: '1px solid #eae2e2',
        }
    },
    actionIcon:{
        cursor:'pointer'
    },
    simpleMenu:{
        marginTop: '37px',
        marginLeft: '-71px'
    },
    menuItem:{
        padding: '.7em',
        display: 'flex',
        fontSize: '1em'
    },
    menuIcon:{
        marginRight:'10px',
        fontSize:'1.3rem'
    },
    rowConatiner: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 0px 10px 0px',
        marginBottom: '10px',
        color:'#757575',
        textAlign: 'center'
    },
    navContainer: {
        height: '35px',
        borderRadius: '18px',
        cursor:'pointer'
    },
    leftNav: {
        background: 'white',
        border: 'solid 1px #e0e0e0',
        borderBottomLeftRadius: '20px',
        borderTopLeftRadius: '20px',
    },
    middleNav: {
        background: 'white',
        border: 'solid 1px #e0e0e0',
    },
    rightNav: {
        background: 'white',
        border: 'solid 1px #e0e0e0',
        borderBottomRightRadius: '20px',
        borderTopRightRadius: '20px',
    },
    activeNav: {
        backgroundColor: '#01579b',
        color: '#ffffff',
    },
    errortoaster: {
        backgroundColor: colorConstant.errorToaster,
        // borderRadius: 40,
        textAlign: 'center',
        fontSize: 12
    },
    successtoaster: {
        backgroundColor: colorConstant.successToaster,
        // borderRadius: 40,
        textAlign: 'center',
        fontSize: 12
    },
}));
